import {
  dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
  dimensiondata_2_termekek_group_1_2_3_column,
  kilo_tonna_value_1_data_precision,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesOlajMerlegConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: true,
  filterYear: {numberOfYears: 4},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesOlajMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_1_2_3_column,
      kilo_tonna_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
